import { render } from "./BaseTableWithFilter.vue?vue&type=template&id=71ae72d9&ts=true"
import script from "./BaseTableWithFilter.vue?vue&type=script&lang=ts"
export * from "./BaseTableWithFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__